import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 企业人员管理
 */
export class EmployeeExpControllerSvr {
    constructor() {
        this.baseurl = 'EmployeeExpControllerSvr.assx/';
    }

    /**
     * 根据物业企业编号获得从业人员
     * token:String, orgCode:String, startIndex:int, maxSize:int
     */
    GetEmployeeByOrgCode(token, orgCode, startIndex, maxSize){
        return request.post(this.baseurl + 'GetEmployeeByOrgCode', Qs.stringify({ token:token, orgCode:orgCode, startIndex:startIndex, maxSize:maxSize }));
    }
    /**
     * 获取项目经理列表
     * openId:String, name:String, startIndex:int, maxSize:int
     */
    GetEmployeeListByPerson(openId, name, startIndex, maxSize){
        return request.post(this.baseurl + 'GetEmployeeListByPerson', Qs.stringify({ openId:openId, name:name, startIndex:startIndex, maxSize:maxSize }));
    }
    /**
     * 删除
     * token:String, employeeNumber:String
     */
    DeleteEmployee(token, employeeNumber){
        return request.post(this.baseurl + 'DeleteEmployee', Qs.stringify({ token:token, employeeNumber:employeeNumber }));
    }

    /**
     * 获取单个信息 
     * token:String, employeeNumber:String, reslutChild:boolean
     */
    GetEmployee(token, employeeNumber, reslutChild){
        return request.post(this.baseurl + 'GetEmployee', Qs.stringify({ token:token, employeeNumber:employeeNumber, reslutChild:reslutChild }));
    }

    /**
     * 添加
     * token:String, data:Employee
     */
    AddEmployee(token, data){
        return request.post(this.baseurl + 'AddEmployee', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 获取物业企业的从业人员统计信息，只用于物管企业的信息
     * token:String
     */
    GetEmployeeStatics4RealtyCom(token){
        return request.post(this.baseurl + 'GetEmployeeStatics4RealtyCom', Qs.stringify({ token:token }));
    }

    /**
     * 获取物业区域责任人
     * token:String, eaAreaCode:String
     */
    GetEmployeeByCode(token, eaAreaCode){
        return request.post(this.baseurl + 'GetEmployeeByCode', Qs.stringify({ token:token, eaAreaCode:eaAreaCode }));
    }

    /**
     * 修改
     * token:String, data:Employee
     */
    ModifyEmployee(token, data){
        return request.post(this.baseurl + 'ModifyEmployee', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 获取从业人员列表
     * token:String, orgCode:String, eaAreaCode:String, name:String, orgNme:String, jobType:int, startIndex:int, maxSize:int
     */
    getEmployeeList(token, orgCode, eaAreaCode, name, orgNme, jobType, startIndex, maxSize){
        return request.post(this.baseurl + 'getEmployeeList', Qs.stringify({ token:token, orgCode:orgCode, eaAreaCode:eaAreaCode, name:name, orgNme:orgNme, jobType:jobType, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 企业人员分专业统计
     * token:String, orgCode:String
     */
    EmployeeStatistics(token, orgCode){
        return request.post(this.baseurl + 'EmployeeStatistics', Qs.stringify({ token:token, orgCode:orgCode }));
    }

    /**
     * 获取列表信息
     * token:String, param:EmployeeQueryPara, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    GetEmployeeList(token, param, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'GetEmployeeList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }
}